var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3262",
    "data-name": "Rectangle 3262",
    width: 18,
    height: 18,
    transform: "translate(-0.002)",
    fill: "#feb730"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_161",
    "data-name": "Mask Group 161",
    transform: "translate(0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "__TEMP__SVG__",
    d: "M11.769,2.769a9,9,0,1,0,9,9A9,9,0,0,0,11.769,2.769Zm-.932,16.658A7.715,7.715,0,0,1,5.9,6.765a8.614,8.614,0,0,1,.087,1.046,3.339,3.339,0,0,0,.43,2.543,4.2,4.2,0,0,1,.407,1.215c.112.383.558.584.866.82.622.476,1.216,1.03,1.874,1.449.435.277.706.414.579.945a3.34,3.34,0,0,1-.352,1.07,2.169,2.169,0,0,0,.361.969c.324.324.646.622,1,.914C11.7,18.188,11.1,18.777,10.837,19.428Zm6.387-2.2a7.661,7.661,0,0,1-4,2.124,3.2,3.2,0,0,1,.947-1.271,3.23,3.23,0,0,0,.852-1.054,7.208,7.208,0,0,1,.588-1c.306-.471-.754-1.183-1.1-1.332a11.324,11.324,0,0,1-2.041-1.271c-.489-.344-1.482.18-2.034-.062a10.637,10.637,0,0,1-2.037-1.4c-.679-.511-.646-1.106-.646-1.86.532.02,1.287-.147,1.64.28.111.135.494.737.75.523.209-.175-.155-.876-.225-1.041-.217-.507.494-.7.857-1.049.474-.449,1.492-1.152,1.411-1.473S11.166,6.1,10.615,6.246c-.082.022-.809.783-.95.9L9.677,6.4c0-.157-.293-.318-.279-.419.034-.256.747-.72.924-.924-.124-.078-.548-.441-.676-.388-.31.129-.661.218-.972.348a1.934,1.934,0,0,0-.029-.309l.609.245.43.511.43.443.375.121.6-.562,1.808-.97V4.136a7.63,7.63,0,0,1,3.268,1.289c-.174.015-.366.041-.583.069a1.864,1.864,0,0,0-.3-.113c.282.607.577,1.207.877,1.806.32.641,1.03,1.327,1.154,2,.147.8.045,1.521.126,2.458a4.2,4.2,0,0,0,1.018,1.929,2.047,2.047,0,0,0,.8.1,7.671,7.671,0,0,1-2.023,3.55Z",
    transform: "translate(-2.769 -2.769)",
    fill: "#feb730"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.d7a3f83f93b78e848ab322dd7d1b8423.svg";
export { ForwardRef as ReactComponent };